__turbopack_context__.v({
  "accentBullets": "ContentSection-module-scss-module__xS8lSW__accentBullets",
  "backgroundRight": "ContentSection-module-scss-module__xS8lSW__backgroundRight",
  "big": "ContentSection-module-scss-module__xS8lSW__big",
  "buttonsWrapper": "ContentSection-module-scss-module__xS8lSW__buttonsWrapper",
  "column": "ContentSection-module-scss-module__xS8lSW__column",
  "contentSection": "ContentSection-module-scss-module__xS8lSW__contentSection",
  "fillLeft": "ContentSection-module-scss-module__xS8lSW__fillLeft",
  "fillRight": "ContentSection-module-scss-module__xS8lSW__fillRight",
  "fitLeft": "ContentSection-module-scss-module__xS8lSW__fitLeft",
  "fitRight": "ContentSection-module-scss-module__xS8lSW__fitRight",
  "form": "ContentSection-module-scss-module__xS8lSW__form",
  "hero": "ContentSection-module-scss-module__xS8lSW__hero",
  "imageWrapper": "ContentSection-module-scss-module__xS8lSW__imageWrapper",
  "inTextContent": "ContentSection-module-scss-module__xS8lSW__inTextContent",
  "rightBackground": "ContentSection-module-scss-module__xS8lSW__rightBackground",
  "small": "ContentSection-module-scss-module__xS8lSW__small",
  "solo": "ContentSection-module-scss-module__xS8lSW__solo",
  "standaloneColumn": "ContentSection-module-scss-module__xS8lSW__standaloneColumn",
  "sunburst": "ContentSection-module-scss-module__xS8lSW__sunburst",
  "tagline": "ContentSection-module-scss-module__xS8lSW__tagline",
  "text": "ContentSection-module-scss-module__xS8lSW__text",
  "textContentWrapper": "ContentSection-module-scss-module__xS8lSW__textContentWrapper",
  "title": "ContentSection-module-scss-module__xS8lSW__title",
  "videoWrapper": "ContentSection-module-scss-module__xS8lSW__videoWrapper",
});
